module.exports = __webpack_public_path__ + "static/media/silverMedal.7f27e561.png";